const RenderSequenceTimeline = (sequence:any) => {
    return (
      <div className="space-y-4">
        {sequence.steps.map((step:any, index:any) => (
          <div key={index} className="flex items-start gap-4">
            <div className="min-w-[60px] text-sm text-gray-500">
              Day {step.day}
            </div>
            <div className="flex-1 p-4 border rounded-lg">
              <div className="font-medium">{step.subject}</div>
              <div className="text-sm text-gray-500">Template: {step.template}</div>
              {step.waitDays && (
                <div className="text-sm text-gray-500">
                  Wait {step.waitDays} days
                </div>
              )}
            </div>
          </div>
        ))}
      </div>
    );
  };
  
  export default RenderSequenceTimeline